import React, { useContext } from 'react';

import PropTypes from 'prop-types';
import Link from '~hooks/link';

import styles from './breadcrumbs.module.scss';
import keygen from '~helpers/keygen';
import { translate } from '~helpers/getters';
import { Context } from '~context/TranslationsProvider';

function Breadcrumbs({ page, separator = <span> / </span> }) {
  const { translations } = useContext(Context) || {};

  if (page.path === '/') {
    return <></>;
  }

  return (
    <ol className={styles.breadcrumbs}>
      <li className={styles.item}>
        <Link to="/" title="Home" className="breadcrumbs-gtm">
          {translate(translations, 'Home', 'Home')}
        </Link>
        {separator}
      </li>
      {page.breadcrumbs &&
        page.breadcrumbs.map((breadcrumb) => (
          <li key={keygen()} className={styles.item}>
            {breadcrumb.path ? (
              <Link to={breadcrumb.path} title={breadcrumb.label} className="breadcrumbs-gtm">
                {breadcrumb.label}
              </Link>
            ) : (
              breadcrumb.label
            )}
            {separator}
          </li>
        ))}
      <li className={styles.item}>{page.vanity_label ? page.vanity_label : page.title}</li>
    </ol>
  );
}

Breadcrumbs.propTypes = {
  page: PropTypes.shape({
    title: PropTypes.string,
    path: PropTypes.string,
    breadcrumbs: PropTypes.arrayOf(PropTypes.object),
    vanity_label: PropTypes.string,
    translations: PropTypes.shape({}),
  }).isRequired,
  separator: PropTypes.element,
};

export default Breadcrumbs;
